import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import data from "../../../../Json/Language/English";
import hindiDatas from "../../../../Json/Language/Hinid";
import "../../../../StyleSheet/MainComponent/UDSEMployee/Leave.scss";

function AttendanceCard(props) {
  const { leaveState, cardType } = props;
  const EnglishData = data;
  const HindiData = hindiDatas;
  const [languageFeed, setLanguageFeed] = useState({});
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const language = useSelector(
    (state) => state.laguagefoetheemployees.COuntsForLanguage
  );
  const state = useSelector((state) => state);
  useEffect(() => {
    if (language == 1) {
      if (cardType === "Permission") {
        setLanguageFeed(EnglishData.permission.ApplyPermissionCard);
      } else if (cardType === "Leave") {
        setLanguageFeed(EnglishData.Home.ApplyLeaveCard.Apply[0]);
      }
    } else if (language == 2) {
      setLanguageFeed(HindiData);
    }
  }, [language]);
   console.log(leaveState ,"leaveState");
   

  return (
    <div className="row LeaveStatusCard ShiftBasedCards ColorPatternForLeaveCards">
      <div className="col-4 ">
        <div className="card ">
          <div className="card-body ">
            <div className="row partOne">
              <div className="col-6 ShiftHeaders ShiftHeadersCardStyle  text-left">
                <span className="permissionCardHead">{languageFeed.Header}</span>
              </div>
              <div className="col-6 text-right DAYS">
                {cardType === "Permission" ? (
                  <>
                    <span> {leaveState.pending_leave}</span>

                  </>
                ) : (
                  <>
                    <span> {leaveState.pending_leave}</span>
                    <span> /</span>
                    <span> {leaveState.total_leave} </span>
                    <span> DAYS</span>
                  </>
                )}
              </div>
            </div>
            {/* <div className="row partTwo">
              <div className="col-12">
                <div class="progress progress-sm ">
                  <div
                    class="progress-bar progressBar"
                    role="progressbar progressBar"
                    style={{
                      width: `${
                        (leaveState.pending_leave / leaveState.total_leave) *
                        100
                      }%`,
                    }}
                    aria-valuenow={leaveState.total_leave}
                    aria-valuemin="0"
                    aria-valuemax="100%"
                  ></div>
                </div>
              </div>
            </div> */}
            
            {/* <div className="row UnTileDate">
              <div className="col-md-12 AttendanceApp text-left">
                <p style={{ margin: "0" }}>
                  {languageFeed.Valid}{" "}
                  <span>{leaveState.leave_valid_until}</span>
                </p>
              </div>
            </div>
            <div className="row partThree">
              <div className="col-12">
                <div class="progress progress-sm ">
                  <div
                    class="progress-bar progressBar"
                    role="progressbar progressBar"
                    style={{
                      width: `${
                        (leaveState.pending_leave / leaveState.total_leave) *
                        100
                      }%`,
                    }}
                    aria-valuenow={leaveState.total_leave}
                    aria-valuemin="0"
                    aria-valuemax="100%"
                  ></div>
                </div>
              </div>
            </div> */}


          </div>
        </div>
      </div>
    </div>
  );
}

export default AttendanceCard;
